import React from "react";
import {inject, observer} from "mobx-react";
import "../../styles/login.css";
import Modal from "react-bulma-components/lib/components/modal";
import Section from "react-bulma-components/lib/components/section";

import {withRouter} from "react-router-dom";
import {removeOverFlowHidden} from "../../helpers/reusable";

@inject('authStore', 'userStore', 'navigatorStore')
@withRouter
@observer
export default class changePWD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: "",
            cpassword: ""
        }
    }


    close(e, info) {
        this.props.navigatorStore.closeLandingModal();
        return;
    }

    render() {
        if (!this.props.userStore.currentUser) {
            return (

                <Modal  show={this.props.navigatorStore.landingModal} onClose={this.close.bind(this)}
                       className="error-modal-layout">
                    <Modal.Content>
                        <Section style={{backgroundColor: 'white', padding: "none",overflow : "auto"}} className="mymodal">
                            <form className="myform">
                                <div style={{textAlign: "left"}} className="log-in mb-0">
                                    Special Announcement
                                    <img onClick={this.close.bind(this)} className="cross-icon-for-masterpieces-modal"
                                         src={require('../../assets/cross_icon_for_close.png')}></img>

                                    <br/>
                                    <p style={{fontWeight: "500"}}>For our android app users</p>
                                </div>
                                <p className="landing-text pl-25 ml-15 mr-15 mt-25 mb-25 pb-25">
                                    <p className="landing-text mr-15">
                                        We have been building the best YourMasterpieces experience for you. A roll-out
                                        of our new updates has begun with our website and iOS app.
                                    </p>
                                    <br/>
                                    <p className="landing-text mr-15">
                                        The new android app will be out soon. You can continue using the old app,
                                        however, we recommend you to use our website and await further announcements on
                                        our new Android update!
                                    </p>
                                    <br/>
                                    <p className="landing-text mr-15">Please note
                                        <br/>

                                        - Likes received on artworks from new website will not be visible on the old
                                        app.
                                        <br/>
                                        - Artworks uploaded on the new website will not be visible on the old app.
                                        <br/>
                                    </p>
                                    <br/>
                                    <p>

                                        Thank you for your love and support,
                                        <br/>

                                        - Team YourMasterpieces
                                    </p>

                                </p>

                            </form>
                        </Section>
                    </Modal.Content>
                </Modal>
            )
        }
        if (this.props.userStore.currentUser) {
            return (
                removeOverFlowHidden(),
                <React.Fragment/>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/static/landingModal.js